import React from 'react';

const MoneyBackGuarantee = () => {
    const scrollToForm = () => {
    const formSection = document.getElementById('contact-form');
    formSection?.scrollIntoView({ behavior: 'smooth' });
  };
  return (
    <div className="w-full bg-white py-8 px-4 md:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="bg-gradient-to-r bg-[#44576D] rounded-2xl md:rounded-3xl px-5 py-8 md:py-12 shadow-xl">
          <div className="text-center">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold    text-white mb-3 md:mb-4" style={{ fontFamily: 'Segoe UI' }}>
              90-Day Money-Back Guarantee
            </h2>
            <p className="text-sm md:text-base lg:text-md text-white max-w-xl mx-auto leading-relaxed" style={{ fontFamily: 'Segoe UI' }}>
              Try Erexel risk-free. If you're not satisfied, within 90 days for a full refund.
              <br className="hidden md:block" />
              <span className="block md:inline md:ml-1">No questions asked.</span>
            </p>
            <button
              onClick={scrollToForm}
              className="bg-white text-[#44576D] font-semibold px-8 md:px-28 mt-3 py-3 md:py-4 rounded-md shadow text-base md:text-lg"
            >
              Buy Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoneyBackGuarantee;